export const dataLayerPushEcommerce = data => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
}

export const onCheckoutOption = (step, checkoutOption) => {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    'event': 'checkoutOption',
    'ecommerce': {
      'checkout_option': {
        'actionField': {'step': step, 'option': checkoutOption}
      }
    }
  });
}

export const dataLayerAddToCart = (gtmEcommerceItems) => {
    dataLayerPushEcommerce({
        event: "gtm_add_to_cart",
        ecommerce: {
            items: gtmEcommerceItems
        }
    });
}

export const dataLayerGtmShowCart = (cart) => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      'event': 'gtm_view_cart',
      'ecommerce': {
        'currency': cart.currency,
        'value': cart.gtmGrandTotal,
        'items': cart.orderRows.map(r => r.gtmEcommerceItem),
      },
    });
}
